"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isNotEmptyOrUndefined = void 0;

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

var _propTypes = require("prop-types");

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash"));

var isNotEmptyOrUndefined = function isNotEmptyOrUndefined() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return !!string && !_lodash["default"].isEmpty("".concat(string).trim());
};

exports.isNotEmptyOrUndefined = isNotEmptyOrUndefined;
var QuestionDescriptionLabel = (0, _styledComponents["default"])(_formElements.InputLabel).withConfig({
  displayName: "fieldWrapper__QuestionDescriptionLabel"
})(["margin-bottom:10px;"]);

var FieldWrapper = function FieldWrapper(props) {
  var title = props.title,
      children = props.children,
      question_description = props.question_description,
      smallLabel = props.smallLabel,
      description = props.description,
      labelStyle = props.labelStyle,
      style = props.style;

  var Content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, description !== "" && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    labelStyle: labelStyle,
    label: "".concat(description),
    style: {
      fontSize: "80%"
    }
  }));

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: style
  }, isNotEmptyOrUndefined(title) && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "content-title",
    dangerouslySetInnerHTML: {
      __html: "".concat(title)
    }
  }), isNotEmptyOrUndefined(smallLabel) && /*#__PURE__*/_react["default"].createElement(QuestionDescriptionLabel, {
    labelStyle: labelStyle,
    label: "".concat(smallLabel)
  }), isNotEmptyOrUndefined(question_description) && /*#__PURE__*/_react["default"].createElement(QuestionDescriptionLabel, {
    labelStyle: labelStyle,
    label: "".concat(question_description)
  }), Content);
};

FieldWrapper.defaultProps = {
  title: "",
  question_description: "",
  smallLabel: "",
  description: "",
  labelStyle: "dark",
  style: {},
  collapseable: false
};
FieldWrapper.propTypes = {
  title: _propTypes.string,
  description: _propTypes.string,
  labelStyle: _propTypes.string,
  question_description: _propTypes.string,
  style: _propTypes.object,
  collapseable: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.object])
};
var _default = FieldWrapper;
exports["default"] = _default;